import React from 'react';

const NetworkIcon = () => {

  return (
    <svg width="67px" height="67px" viewBox="0 0 67 67" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <title>wifi actv</title>
      <desc>Created with Sketch.</desc>
      <g id="Final-version" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Logging_A_Lead_Desktop_1440_Submission_Confirmation_High_Fidelity" transform="translate(-1117.000000, -810.000000)" stroke="#007E92" strokeWidth="3">
          <g id="wifi-actv" transform="translate(1119.000000, 812.000000)">
            <polyline id="Path" points="43.363844 62.575 31.6596773 22.575 19.9555107 62.575 38.2555107 45.1166667"></polyline>
            <polyline id="Path" points="19.9555107 62.575 31.6596773 22.575 43.363844 62.575 25.0596773 45.1291667"></polyline>
            <path d="M23.7221773,12.8333333 C21.3365362,15.214208 19.9958955,18.4462293 19.9958955,21.8166667 C19.9958955,25.1871041 21.3365362,28.4191253 23.7221773,30.8" id="Path"></path>
            <path d="M16.3846773,6.41666667 C12.2929979,10.4979445 9.99343996,16.0395918 9.99343996,21.81875 C9.99343996,27.5979082 12.2929979,33.1395555 16.3846773,37.2208333" id="Path"></path>
            <path d="M9.04717734,0 C3.25483335,5.78369108 0,13.6332548 0,21.81875 C0,30.0042452 3.25483335,37.8538089 9.04717734,43.6375" id="Path"></path>
            <path d="M39.5971773,12.8333333 C41.9828185,15.214208 43.3234592,18.4462293 43.3234592,21.8166667 C43.3234592,25.1871041 41.9828185,28.4191253 39.5971773,30.8" id="Path"></path>
            <path d="M46.9346773,6.41666667 C51.0263567,10.4979445 53.3259147,16.0395918 53.3259147,21.81875 C53.3259147,27.5979082 51.0263567,33.1395555 46.9346773,37.2208333" id="Path"></path>
            <path d="M54.2721773,2.13162821e-14 C60.0645213,5.78369108 63.3193547,13.6332548 63.3193547,21.81875 C63.3193547,30.0042452 60.0645213,37.8538089 54.2721773,43.6375" id="Path"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}



export default NetworkIcon;